import { Col, Row } from 'reactstrap';

import Input from 'src/componentes/input';
import GeneroLookup from 'src/lookups/GeneroLookup';
import RacaLookup from 'src/lookups/RacaLookup';
import OrientacaoSexualLookup from 'src/lookups/OrientacaoSexualLookup';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const PessoalSection = ({ model, intl, campos, searchQuery }) => {
  const pessoalSecaoVisivel =
    campos[COLABORADOR_CAMPOS.GENERO] ||
    campos[COLABORADOR_CAMPOS.NOME_SOCIAL] ||
    campos[COLABORADOR_CAMPOS.RACA] ||
    campos[COLABORADOR_CAMPOS.ORIENTACAO_SEXUAL];

  if (!pessoalSecaoVisivel) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [
    intl.formatMessage({ id: 'pessoal' }),
    intl.formatMessage({ id: 'genero' }),
    intl.formatMessage({ id: 'nomeSocial' }),
    intl.formatMessage({ id: 'raca' }),
    intl.formatMessage({ id: 'orientacaoSexual' }),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'pessoal' })} enabled={false}>
      <Row>
        {campos[COLABORADOR_CAMPOS.GENERO] &&
          fieldMatches([intl.formatMessage({ id: 'genero' })]) && (
            <Col md={12}>
              <GeneroLookup model={model.getModel('genero')} clearable />
            </Col>
          )}
        {campos[COLABORADOR_CAMPOS.NOME_SOCIAL] &&
          fieldMatches([intl.formatMessage({ id: 'nomeSocial' })]) && (
            <Col md={12}>
              <Input model={model.getModel('nomeSocial')} />
            </Col>
          )}
        {campos[COLABORADOR_CAMPOS.RACA] &&
          fieldMatches([intl.formatMessage({ id: 'raca' })]) && (
            <Col md={12}>
              <RacaLookup model={model.getModel('raca')} clearable />
            </Col>
          )}
        {campos[COLABORADOR_CAMPOS.ORIENTACAO_SEXUAL] &&
          fieldMatches([intl.formatMessage({ id: 'orientacaoSexual' })]) && (
            <Col md={12}>
              <OrientacaoSexualLookup model={model.getModel('orientacaoSexual')} clearable />
            </Col>
          )}
      </Row>
    </CollapsibleSection>
  );
};

export default PessoalSection;
